"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-nine/sections/testimonialSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TestimonialSection6sItem = {
    key: Key | null | undefined;
    /** Detected variants: "5 days ago" | "2 days ago" */
    span0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/partners/testimonial-img-one.jpg" | "/Templates/Doccure/img/partners/testimonial-img-two.jpg" */
    src: string;
    /** Detected variants: "col-sm-6 d-flex" */
    className?: string;
    /** Detected variants: "testimonial-item-nine flex-fill wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "testimonial-content" */
    div0ClassName2?: string;
    /** Detected variants: "review" */
    div0ClassName3?: string;
    /** Detected variants: "testimonial-date" */
    div1ClassName?: string;
    /** Detected variants: "isax isax-calendar" */
    i0ClassName?: string;
    /** Detected variants: "Exceptional cardiology care with precise diagnosis, advanced treatment options, and compassionate support throughout the journey. The team ensures timely monitoring, clear communication" */
    p0Text?: ReactNode;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "testimonial-author" */
    div1ClassName2?: string;
    /** Detected variants: "testimonial-img" */
    alt?: string;
    /** Detected variants: "img-fluid img-one" */
    imageWithBasePath0ClassName?: string;
    reviewStarItems?: TestimonialSectionFaSolidFaStarsItem[];
};

type TestimonialSectionFaSolidFaStarsItem = {
    key: Key | null | undefined;
    /** Detected variants: "fa-solid fa-star" */
    className?: string;
};
export type HomeNineTestimonialSectionGeneratedProps = {
    divDiv0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "CLIENT REVIEWS" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "What people say" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "about us worldwide" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "#" */
    sectionDiv0Div2Link0LinkHref?: string;
    /** Default: "View All Testimonials" */
    sectionDiv0Div2Link0LinkText?: ReactNode;
    sectionDiv0Div2Link0LinkVisible?: boolean;
    sectionDiv0Div2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "element" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/about-element-1.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "testimonial" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/testimonial-icon.svg" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    testimonialSection6s: TestimonialSection6sItem[];
    testimonialSection6sItemWrapper?: (item: TestimonialSection6sItem, content: ReactNode) => ReactNode;
    testimonialSection6sRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonialSection6sImageVisible?: boolean;
    testimonialSection6sImageRenderer?: (item: TestimonialSection6sItem, defaultNode: ReactNode) => ReactNode;
    testimonialSection6sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    testimonialSectionFaSolidFaStarsItemWrapper?: (item: TestimonialSectionFaSolidFaStarsItem, content: ReactNode) => ReactNode;
    testimonialSectionFaSolidFaStarsRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeNineTestimonialSectionGenerated: FC<HomeNineTestimonialSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "CLIENT REVIEWS",
    sectionDiv0Div0H20H2Text = "What people say",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "about us worldwide",
    sectionDiv0Div2Link0LinkHref = "#",
    sectionDiv0Div2Link0LinkText = "View All Testimonials",
    sectionDiv0Div2Link0LinkVisible,
    sectionDiv0Div2Link0LinkRenderer,
    sectionDiv0Div2Link0LinkProps,
    sectionImageWithBasePath0ImageAlt = "element",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/about-element-1.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "testimonial",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/testimonial-icon.svg",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0Div1ImageWithBasePath0ImageProps,
    sectionDiv0Div1ClassName,
    testimonialSection6s,
    testimonialSection6sItemWrapper,
    testimonialSection6sRenderer,
    testimonialSection6sImageVisible,
    testimonialSection6sImageRenderer,
    testimonialSection6sImageProps,
    testimonialSectionFaSolidFaStarsItemWrapper,
    testimonialSectionFaSolidFaStarsRenderer,
}) => {
    return (
        <section className="testimonial-section-nine section">
            <div className="container">
                <div className="section-header section-header-nine text-center">
                    <div className="title">
                        <span className="dot" />
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {" "}
                            {sectionDiv0Div0H20H2Text}
                            {" "}
                            <span className="text-primary text-decoration-underline">
                                {" "}
                                {sectionDiv0Div0H20Span0SpanText}
                            </span>
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        testimonialSection6s,
                        (item: TestimonialSection6sItem) => (
                            <div className={item.className ?? "col-sm-6 d-flex"} key={item.key}>
                                <div className={item.div0ClassName ?? "testimonial-item-nine flex-fill wow fadeInUp"} data-wow-duration={item.dataWowDuration ?? "1s"}>
                                    <div className={item.div0ClassName2 ?? "testimonial-content"}>
                                        <p className={item.p0ClassName ?? "description"}>
                                            {" "}
                                            {item.p0Text ?? "Exceptional cardiology care with precise diagnosis, advanced treatment options, and compassionate support throughout the journey. The team ensures timely monitoring, clear communication"}
                                            {" "}
                                        </p>
                                        <div className={item.div0ClassName3 ?? "review"}>
                                            <div className="review-star">
                                                {renderCollectionNode(
                                                    item.reviewStarItems ?? [],
                                                    (item: TestimonialSectionFaSolidFaStarsItem) => (
                                                        <i className={item.className ?? "fa-solid fa-star"} key={item.key} />
                                                    ),
                                                    testimonialSectionFaSolidFaStarsItemWrapper,
                                                    testimonialSectionFaSolidFaStarsRenderer
                                                )}
                                            </div>
                                            <div className={item.div1ClassName ?? "testimonial-date"}>
                                                <i className={item.i0ClassName ?? "isax isax-calendar"} />
                                                <span>{item.span0Text}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={item.div1ClassName2 ?? "testimonial-author"}>
                                        {renderItemNode(testimonialSection6sImageVisible, testimonialSection6sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "testimonial-img"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-one"} {...(typeof testimonialSection6sImageProps === "function" ? testimonialSection6sImageProps(item) : (testimonialSection6sImageProps ?? {}))} {...(typeof divDiv0Div1ImageWithBasePath0ImageProps === "function" ? divDiv0Div1ImageWithBasePath0ImageProps(item) : (divDiv0Div1ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ),
                        testimonialSection6sItemWrapper,
                        testimonialSection6sRenderer
                    )}
                </div>
                <div className="view-all text-center">
                    {renderNode(sectionDiv0Div2Link0LinkVisible, sectionDiv0Div2Link0LinkRenderer, (
                        <SmartLink href={sectionDiv0Div2Link0LinkHref} className="btn btn-primary-gradient d-inline-flex align-items-center" {...(sectionDiv0Div2Link0LinkProps ?? {})}>
                            {" "}
                            <i className="isax isax-arrow-right-1 me-2" />
                            {sectionDiv0Div2Link0LinkText}
                        </SmartLink>
                    ))}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-one" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid testimonial-icon" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeNineTestimonialSectionGenerated;
